import { auth } from '../../../auth';
import { LeaveOrgQueryParam } from '../../OrganizationCard';

const stripLeaveOrgAndRedirectQueryParams = () => {
  const url = new URL(location.href);
  url.searchParams.delete(LeaveOrgQueryParam.tenantIdToLeave);
  url.searchParams.delete(LeaveOrgQueryParam.tenantIdToRedirectBackTo);
  const newUrl = url.toString();
  window.history.pushState({ path: newUrl }, '', newUrl);
};

export const loginToRedirectTenant = () => {
  const url = new URL(location.href);
  const redirectBackToTenantId = url.searchParams.get(LeaveOrgQueryParam.tenantIdToRedirectBackTo);
  if (redirectBackToTenantId !== null) {
    stripLeaveOrgAndRedirectQueryParams();
    auth.login({ tenantId: redirectBackToTenantId });
  } else {
    auth.login();
  }
};
